module.exports = "/call-frontend/img/signup-top.c72838ac.png";